import { ValueFormatterParams } from "ag-grid-community";

export enum YesOrNo {
  YES = 'SI',
  NO = 'NO'
}

export enum State {
  ACTIVE = 'Activo',
  INACTIVE = 'Inactivo'
}

export enum Apply {
  YES = 'SI',
  NO = 'NO',
  NOT_APPLY = 'N/A'
}

export enum RetencionType {
  NO_RETENCION = 'Sin retencion',
  SOURCE = 'Fuente',
  IVA = 'IVA'
}

export enum Support {
  NO_SUPPORT = 'Ninguno',
  IMMEDIATE = 'Inmediato',
  PENDING = 'Posterior'
}

export enum AccountType {
  DEFINED = 'Cta. Definida',
  CLIENT = 'Cta. Cliente',
  BANK = 'Cta. Banco',
  DEPOSIT = 'Cta. Depósito',
}

export enum LockStatus {
  LOCKED = 'Bloqueado',
  UNLOCKED = 'Desbloqueado',
  REJECTED = 'Rechazado',
  DUPLICATE = 'Duplicado',
  DIVISION_INVALIDA = 'División no válida',
}

export enum RutaStatus {
  NOAPLICA = '',
  ESPERA = 'En espera',
  AUTORIZADO = 'Autorizado',
  RECHAZADO = 'Rechazado',
}
export enum OrigenPedidoStatus {
  VENDEDOR = 'Vendedor',
  TECNICO = 'Tecnico.',
  APROBADO = 'Aprobado',
  RECHAZADO = 'Rechazado',
}


export function getYesOrNo(value: number | boolean): YesOrNo {
  return value ? YesOrNo.YES : YesOrNo.NO;
}

export function getActive(value: number | boolean): State {
  return value ? State.ACTIVE : State.INACTIVE;
}

export function getNotApply(value: number): Apply {
  if (value === 0) return Apply.NO;
  else if (value === 1) return Apply.YES;
  else return Apply.NOT_APPLY;
}

export function getRetencionType(value: number): RetencionType {
  if (value === 0) return RetencionType.NO_RETENCION;
  else if (value === 1) return RetencionType.SOURCE;
  else return RetencionType.IVA;
}

export function getSustento(value: number): Support {
  if (value === 0) return Support.NO_SUPPORT;
  else if (value === 1) return Support.IMMEDIATE;
  else return Support.PENDING;
}

export function getAccountType(value: number): AccountType {
  if (value === 1) return AccountType.DEFINED;
  else if (value === 2) return AccountType.CLIENT;
  else return AccountType.BANK;
}

export function getLockStatus(value: number) {
  if (value === 1) return LockStatus.LOCKED;
  else if (value === 2) return LockStatus.UNLOCKED;
  else if (value === 3) return LockStatus.REJECTED;
  else if (value === 4) return LockStatus.DUPLICATE;
  else if (value === 7) return LockStatus.DIVISION_INVALIDA;
  else return '';
}


export function dateFormatter(params: ValueFormatterParams) {
  let value: string = params.value;
  return value.split('T')[0];
}

export function getOrigenStatus(value: number) {
  if (value === 0) return OrigenPedidoStatus.VENDEDOR;
  else if (value === 1) return OrigenPedidoStatus.TECNICO;
  else if (value === 2) return OrigenPedidoStatus.APROBADO;
  else if (value === 3) return OrigenPedidoStatus.RECHAZADO;
  else return '';
}

export function getRutasStatus(value: number) {
  if (value === 0) return RutaStatus.NOAPLICA;
  else if (value === 1) return RutaStatus.AUTORIZADO;
  else if (value === 2) return RutaStatus.RECHAZADO;
  else if (value === 9) return RutaStatus.ESPERA;
  else return '';
}
